<div mat-dialog-container>
  <div class="content">
    <div class="dialog-header">
      <span class="dialog-title">{{ 'PROFILE.IMAGETITLE' | translate }}</span>
      <button
        mat-icon-button
        class="close-button"
        [mat-dialog-close]="data.selectedFileUrl">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    @if (!isCropperOpen && !showPreview) {
      <div class="center">
        <app-file-drop
          accept="image/*"
          dropZoneLabel="Drop files here"
          (fileDropEvent)="dropped($event)"
          dropZoneClassName="drop-zone"
          contentClassName="drop-content">
          <ng-template
            appFileDropContentTmp
            let-openFileSelector="openFileSelector">
            <div [innerHTML]="'PROFILE.DROPIMAGE' | translate"></div>
            <button
              type="button"
              (click)="openFileSelector()"
              mat-raised-button
              color="accent">
              {{ 'PROFILE.SELECTIMAGE' | translate }}
            </button>
            @if (!validFileFormat) {
              <div class="invalidFileFormat">
                <p>
                  {{ 'ERROR.INVALIDFILE1' | translate
                  }}<strong>{{ this.invalidFileType }}</strong
                  >{{ 'ERROR.INVALIDFILE2' | translate }}
                </p>
              </div>
            }
            @if (!validFileResolution) {
              <div class="invalidFileFormat">
                <p>{{ 'ERROR.INVALIDFILERESOLUTION' | translate }}</p>
              </div>
            }
          </ng-template>
        </app-file-drop>
      </div>
    }
    <div class="content-container">
      @if (isCropperOpen) {
        <div class="profile-picture-container">
          <div class="profile-picture">
            <image-cropper
              class="cropper"
              [imageChangedEvent]="imageChangedEvent"
              [imageBase64]="this.base64String"
              [maintainAspectRatio]="true"
              [aspectRatio]="1"
              format="jpeg"
              [resizeToHeight]="1080"
              [onlyScaleDown]="true"
              [roundCropper]="true"
              [transform]="transform"
              (imageCropped)="imageCropped($event)">
            </image-cropper>
          </div>
        </div>
      }
      @if (isCropperOpen) {
        <div class="slider-container">
          <div class="zoom-controls">
            <input
              type="range"
              min="0.1"
              max="3"
              step="0.1"
              [(ngModel)]="scale"
              (input)="applyZoom()"
              (wheel)="handleMouseWheel($event)" />
          </div>
        </div>
      }
      <div class="buttons-container">
        @if (isCropperOpen) {
          <button class="action-button" (click)="validate()" mat-raised-button>
            {{ 'VALIDATION.STEPFOUR.TITLE' | translate }}
          </button>
        }
        @if (isCropperOpen) {
          <button
            class="action-button"
            (click)="closeCropper()"
            mat-raised-button>
            {{ 'GENERAL.RETURN' | translate }}
          </button>
        }
      </div>
    </div>
    @if (showPreview) {
      <div class="content-container preview-margin">
        <div class="profile-picture-container">
          <div class="profile-image">
            <img
              class="profile-image-dialog"
              [src]="this.croppedImage"
              alt="Profile picture" />
          </div>
          @if (this.data.isSelf) {
            <div class="checkboxes">
              <div class="checkbox-container">
                <mat-checkbox
                  [(ngModel)]="agreeTermsOne"
                  class="checkbox-only"></mat-checkbox>
                <span class="checkbox-text">{{
                  'PROFILE.AGREETERMONE' | translate
                }}</span>
              </div>
              <div class="checkbox-container">
                <mat-checkbox
                  [(ngModel)]="agreeTermsTwo"
                  class="checkbox-only"></mat-checkbox>
                <span class="checkbox-text">{{
                  'PROFILE.AGREETERMTWO' | translate
                }}</span>
              </div>
              <span style="opacity: 80%; margin-left: 47px">{{
                'PROFILE.LEGAL10' | translate
              }}</span>
            </div>
          }
          <div class="buttons-container">
            <button
              [disabled]="this.data.isSelf && !(agreeTermsOne && agreeTermsTwo)"
              class="action-button"
              (click)="this.data.isSelf ? saveImageSelf() : saveImage()"
              mat-raised-button
              color="accent">
              {{ 'GENERAL.SAVE' | translate }}
            </button>
          </div>
        </div>
      </div>
    }
  </div>
</div>
